<span (click)="close()" style="padding: 0px ; HEIGHT: 0PX;margin: 0px;" mat-dialog-title>
    <span (click)="close()" fxLayout="row" fxLayoutAlign="end center">
        <button style="background-color:white; border-radius:20px;z-index: 10;" (click)="close()" mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </span>
</span>


<div>
    <mat-dialog-content style=" margin: 0px;  max-height: 100%;
    padding: 20px;">
        <div style="width:100%;">
            <!-- <img style="width:100%;" [src]="serverPath + adsHomePageImage" flex="100"
                [alt]="serverPath + adsHomePageImage" /> -->
             <video oncanplay="this.play()" onloadedmetadata="this.muted = true" autoplay loop  playsinline="playsinline" #videoPlayer width="100%" >
                <source [src]="serverPath + adsHomePageImage" type="video/mp4">
                Your browser does not support the video tag.
            </video>
        </div>

    </mat-dialog-content>
</div>

